__turbopack_context__.v({
  "close": "index-module__TSprCa__close",
  "content": "index-module__TSprCa__content",
  "description": "index-module__TSprCa__description",
  "overlay": "index-module__TSprCa__overlay",
  "title": "index-module__TSprCa__title",
  "wrapper": "index-module__TSprCa__wrapper",
});
